import { Box, Stack } from '@mui/material'
import { IDiagnosisBlock, PositionHoof } from 'models'
import { COLORS } from 'styles/colors'
import { HoofPicker } from 'ui/HoofPicker/HoofPicker'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'

const HOOVES_ORDER = [
	PositionHoof.Front_Left,
	PositionHoof.Front_Right,
	PositionHoof.Rear_Left,
	PositionHoof.Rear_Right,
]

type HoofPickerSectionProps = {
	selectedHoof: PositionHoof | null
	setSelectedHoof: (hoof: PositionHoof | null) => void
	diagnosis: IDiagnosisBlock[]
	isSubmitAttempted: boolean
	hasCompleteDiagnosis: boolean
}

export const HoofPickerSection = ({
	selectedHoof,
	setSelectedHoof,
	diagnosis,
	isSubmitAttempted,
	hasCompleteDiagnosis,
}: HoofPickerSectionProps) => {
	const getHoofCount = (hoof: PositionHoof): number => {
		const item = diagnosis.find(d => d.position === hoof)
		if (!item) return 0

		return Math.max(item.sickness?.length ?? 0, item.sickness_id?.length ?? 0)
	}
	const showDiagnosisError =
		isSubmitAttempted && !hasCompleteDiagnosis && selectedHoof === null

	return (
		<Stack direction='column' gap='27px'>
			<TypographyPrimary14Bold
				sx={{ color: showDiagnosisError ? COLORS.error : COLORS.black }}
			>
				Выберите копыто
			</TypographyPrimary14Bold>
			<Box
				display='grid'
				gridTemplateColumns='repeat(2, auto)'
				gap='16px'
				width='max-content'
			>
				{HOOVES_ORDER.map(hoof => (
					<HoofPicker
						key={hoof}
						placement={hoof}
						count={getHoofCount(hoof)}
						active={selectedHoof === hoof}
						hasError={
							isSubmitAttempted &&
							!hasCompleteDiagnosis &&
							selectedHoof !== null &&
							selectedHoof !== hoof
						}
						onClick={() =>
							selectedHoof === hoof
								? setSelectedHoof(null)
								: setSelectedHoof(hoof)
						}
					/>
				))}
			</Box>
		</Stack>
	)
}
